var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['hamburger-box', _vm.openSidebar ? '' : 'rotate'],on:{"click":_vm.toggleSideBar}},[_c('svg-icon',{attrs:{"iconClass":"hamburger-menu","className":"hamburger-menu"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }